// Mapping of variant IDs to their specific benefits
const variantBenefitsMap = {
  // Variants with updated benefits list (all except 44140962873398)
  '52682272637270': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682535567702': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682447356246': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682432807254': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '44760214732854': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44760215027766': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44760227381302': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227414070': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227446838': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227479606': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227512374': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227545142': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  // Variant 44140962873398: updated list without "Swap flavors anytime" ($3.00)
  '44140962873398': [
    'Enjoy 10% off on every order ($3.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44239538356278': [
    'Enjoy 10% off on every order ($3.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44336518561846': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784753119286': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784753905718': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784755052598': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44336496312374': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784754561078': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  // Mexican pesos (MXN) variants – English copy with MXN amounts
  '44336530554934': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030751014966': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030753964086': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44336499032118': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44031252496438': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030750130230': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    '6-Flavor Sample Pack with your 2nd order',
    'Swap flavors anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ]
};

// Spanish benefits copy (used when #shop-language-locale value is "es")
const variantBenefitsMapEs = {
  '44683455889462': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44683455922230': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44683455954998': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760214601782': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760214732854': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760215027766': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227381302': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227414070': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227446838': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227479606': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227512374': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227545142': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],

  // 44140962873398: updated list without "Swap flavors" ($3.00)
  '44140962873398': [
    'Disfruta 10% de descuento en cada pedido ($3.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],

  '44239538356278': [
    'Disfruta 10% de descuento en cada pedido ($60)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44336518561846': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784753119286': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784753905718': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784755052598': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44336496312374': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784754561078': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  // Mexican pesos (MXN) variants
  '44336530554934': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030751014966': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030753964086': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44336499032118': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44031252496438': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030750130230': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ]
};

// Mapping of variant IDs to delivery frequency (in days)
const variantDeliveryDaysMap = {
  '52682272637270': 30,
  '52682535567702': 30,
  '52682447356246': 30,
  '52682432807254': 30,
  '44760214732854': 30,
  '44760215027766': 30,
  '44760214732854': 30,
  '44760227381302': 30,
  '44760227414070': 30,
  '44760227446838': 30,
  '44760227479606': 30,
  '44760227512374': 30,
  '44760227545142': 30,
  '44140962873398': 60,  // New variant delivers every 60 days
  '44239538356278': 60,
  '44336518561846': 30,
  '43784753119286': 30,
  '43784753905718': 30,
  '43784755052598': 30,
  '44336496312374': 30,
  '43784754561078': 30,
  '44336530554934': 30,
  '44030751014966': 30,
  '44030753964086': 30,
  '44336499032118': 30,
  '44031252496438': 30,
  '44030750130230': 30
};

function stripTrailingCurrencyCode(text) {
  if (!text) return text;
  return String(text).replace(/\s*(EUR|USD|GBP|MXN)\s*$/i, '').trim();
}

function normalizeWidgetPriceElements(root) {
  if (!root) return;
  root.querySelectorAll('.in_widget_price').forEach(function (priceEl) {
    var cleaned = stripTrailingCurrencyCode(priceEl.textContent);
    if (cleaned !== priceEl.textContent) {
      priceEl.textContent = cleaned;
    }
  });
}

function injectSubscriptionBenefits() {
    console.log('Executing injectSubscriptionBenefits...');

    const localeInput = document.getElementById('shop-language-locale');
    const locale = (localeInput && localeInput.value ? String(localeInput.value) : '').trim().toLowerCase();
    const isSpanish = locale === 'es';
    
    // Array with variant IDs
    const variantIds = [
      '52682272637270',
      '52682535567702',
      '52682447356246',
      '52682432807254',
      '44760214732854',
      '44760215027766',
      '44140962873398',
      '44239538356278',
      '44336518561846',
      '43784753119286',
      '43784753905718',
      '43784755052598',
      '44336496312374',
      '43784754561078',
      '44760227381302',
      '44760227414070',
      '44760227446838',
      '44760227479606',
      '44760227512374',
      '44760227545142',
      '44336530554934',
      '44030751014966',
      '44030753964086',
      '44336499032118',
      '44031252496438',
      '44030750130230'
    ];
    
    variantIds.forEach(variantId => {
      // Select the specific section by data-variant-id
      const section = document.querySelector(`section[data-variant-id="${variantId}"]`);
      console.log(`Section found for variant ${variantId}:`, section);
      
      if (section) {
        normalizeWidgetPriceElements(section);

        // Check if content was already injected to avoid duplicates
        if (section.querySelector('.benefits-injected')) {
          console.log(`Content already injected for variant ${variantId}, skipping...`);
          return;
        }
        
        // New app block structure: .plan_card > .subscription_group (one-time, then subscription)
        const planCard = section.querySelector('.plan_card');
        const subscriptionGroups = planCard ? planCard.querySelectorAll('.subscription_group') : [];
        // First group = one-time purchase, second = subscription (has .group_list and no .one_time_purchase_option_app_block)
        let oneTimeGroup = null;
        let subscribeGroup = null;
        const tenPercentPlanId = '690676990294';
        const fifteenPercentPlanId = '690718572886';
        subscriptionGroups.forEach(function (grp) {
          if (grp.querySelector('.one_time_purchase_option_app_block')) {
            oneTimeGroup = grp;
          } else {
            // Hide 15% plan group entirely (only show 10% option + benefits).
            if (grp.querySelector('input[data-selling-plan-id="' + fifteenPercentPlanId + '"]')) {
              grp.style.display = 'none';
              return;
            }

            // Prefer the 10% plan group as the subscription container.
            if (!subscribeGroup && grp.querySelector('input[data-selling-plan-id="' + tenPercentPlanId + '"]')) {
              subscribeGroup = grp;
              return;
            }

            // Fallback: if there's only one subscription group and it has a list, use it.
            if (!subscribeGroup && grp.querySelector('.group_list')) {
              subscribeGroup = grp;
            }
          }
        });
        console.log(`Subscription groups found for variant ${variantId}:`, { oneTime: !!oneTimeGroup, subscribe: !!subscribeGroup });

        if (subscribeGroup) {
          // Optional: reorder so subscription appears before one-time (match old behavior)
          if (oneTimeGroup && planCard && oneTimeGroup.nextElementSibling === subscribeGroup) {
            planCard.insertBefore(subscribeGroup, oneTimeGroup);
          }

          // Move subscription radio + price into SUSCRIPCIÓN row: [Radio] SUSCRIPCIÓN [Price] (like one-time row)
          const titlePriceWrapper = subscribeGroup.querySelector(':scope > .title_and_price_wrapper');
          const groupList = subscribeGroup.querySelector('.group_list');
          let subscriptionRadio = null;
          let subscriptionPriceEl = null;
          let radioLi = null;
          if (groupList) {
            const firstLi = groupList.querySelector('li');
            if (firstLi) {
              subscriptionRadio = firstLi.querySelector('input[type="radio"][data-radio-type="selling_plan"]');
              subscriptionPriceEl = firstLi.querySelector('.in_widget_price');
              radioLi = firstLi;
            }
          }
          if (subscriptionRadio && titlePriceWrapper) {
            if (radioLi) radioLi.remove();
            subscriptionRadio.style.marginRight = '8px';
            // Label with two flex parts: left = radio + "SUSCRIPCIÓN", right = price (space-between pushes price right)
            const label = document.createElement('label');
            label.className = titlePriceWrapper.className;
            if (subscriptionRadio.id) label.setAttribute('for', subscriptionRadio.id);
            const leftBlock = document.createElement('div');
            leftBlock.style.display = 'flex';
            leftBlock.style.alignItems = 'baseline';
            leftBlock.appendChild(subscriptionRadio);
            const groupNameSpan = titlePriceWrapper.querySelector('.group_name');
            if (groupNameSpan) leftBlock.appendChild(groupNameSpan);
            label.appendChild(leftBlock);
            if (subscriptionPriceEl) {
              subscriptionPriceEl.textContent = stripTrailingCurrencyCode(subscriptionPriceEl.textContent);
              subscriptionPriceEl.style.marginLeft = 'auto';
              label.appendChild(subscriptionPriceEl);
            }
            titlePriceWrapper.parentNode.replaceChild(label, titlePriceWrapper);
          }

          // Get benefits for this specific variant
          const benefits = (isSpanish ? variantBenefitsMapEs : variantBenefitsMap)[variantId] || [];

          if (benefits.length === 0) {
            console.warn(`No benefits defined for variant ${variantId}`);
            return;
          }

          // Create the benefits list
          const benefitsList = document.createElement('ul');
          benefitsList.style.cssText = 'margin-top: 10px; padding-left: 20px; list-style-type: disc;';
          benefitsList.classList.add('benefits-injected');

          benefits.forEach(function (benefit) {
            const li = document.createElement('li');
            li.textContent = benefit;
            li.style.cssText = 'list-style-type: disc; display: list-item;';
            benefitsList.appendChild(li);
          });

          // Delivery frequency text: below the benefits list
          const deliveryDays = variantDeliveryDaysMap[variantId] || 30;
          const deliveryText = document.createElement('p');
          deliveryText.textContent = 'ENTREGA CADA ' + deliveryDays + ' DIAS';
          deliveryText.style.cssText = 'margin: 10px 0 0 0; font-family: \'Nexa Black\', sans-serif !important; text-transform: uppercase;';

          subscribeGroup.appendChild(benefitsList);
          subscribeGroup.appendChild(deliveryText);
          console.log('Content successfully injected for variant ' + variantId);
        }
      } else {
        console.log(`Section with data-variant-id="${variantId}" not found`);
      }
    });
  }
  
  // Execute on page load
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded');
    injectSubscriptionBenefits();
  });
  
  // Also try with window.load in case content loads after
  window.addEventListener('load', function() {
    console.log('Window loaded');
    setTimeout(injectSubscriptionBenefits, 500);
  });